// ! TODO: move to wag-react
import React, { ReactNode } from "react";
import { Divider } from "@waglabs/divider";
import { Flex, FlexProps } from "@waglabs/flex-next";
export type DividerWithElementProps = {
  children: ReactNode;
} & FlexProps;
export const DividerWithElement = ({
  children,
  ...rest
}: DividerWithElementProps) => <Flex alignItems="center" {...rest}>
    <Divider flex={1} mr="16px" />
    {children}
    <Divider flex={1} ml="16px" />
  </Flex>;